import { app } from '../utils/store';

import each from 'lodash/each';

export default class AsyncLoad {
	constructor({ element }) {
		this.element = element

		this.createObserver()
	}

	createObserver(element) {
		this.observer = new window.IntersectionObserver((entries) => {
			each(entries, (entry) => {
				if (entry.isIntersecting) {
					this.element.src = app.webp === true ?
						(this.element.getAttribute('data-webp') || this.element.src) :
						(this.element.getAttribute('data-src') || this.element.src)
					this.element.onload = () => {
						this.element.setAttribute('loaded', '');
					}
				}
			})
		})

		this.observer.observe(this.element)
	}
}
